export enum FaqThematicAreaEnum {
  BANDI_INCENTIVI = 'bandi e incentivi',
}
